import UserForm from "./UserForm"

const UserMaster = ({open }) => {
    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <UserForm />
        </main>
    )
}
export default UserMaster


